import { render, staticRenderFns } from "./ScissorsIcon.vue?vue&type=template&id=55dddf6c&"
import script from "./ScissorsIcon.vue?vue&type=script&lang=ts&"
export * from "./ScissorsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\adviewer\\AdViewer.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55dddf6c')) {
      api.createRecord('55dddf6c', component.options)
    } else {
      api.reload('55dddf6c', component.options)
    }
    module.hot.accept("./ScissorsIcon.vue?vue&type=template&id=55dddf6c&", function () {
      api.rerender('55dddf6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "wwwroot/src/components/ScissorsIcon.vue"
export default component.exports